import styled from 'styled-components';
import { MdKeyboardArrowRight,MdKeyboardArrowLeft } from "react-icons/md";
import { FaInstagram,FaFacebookSquare,FaTwitter,FaYoutube } from "react-icons/fa";
import { ImQuotesLeft,ImQuotesRight } from "react-icons/im";

export const DivRedesSociaisTopo = styled.div`
width:100%;
height:40px;
display:flex;
margin-top:15px;
padding:0 150px;
@media(max-width:800px){
    padding:0 20px;
    flex-wrap:wrap;
    height:60px;

}
`;

export const DivIconesRedesSociais = styled.div`
display:flex;
align-items:center;
width:50%;
min-height:fit-content;
@media(max-width:500px){
    width:100%;
    justify-content:center;
    margin-bottom:20px;
}
`
export const DivBuscaTopo = styled.div`
    display:flex;
    align-items:center;
    width:50%;
    justify-content:flex-end;
    @media(max-width:500px){
    justify-content:center;
    width:100%;

}
`


export const DivLogoTopo = styled.div`
width:100%;
height:150px;
background-repeat:no-repeat;
background-size:auto;
background-position:center;
background-color:#fff;
margin:30px 0;
display:flex;
justify-content:center;
@media(max-width:500px){
    background-size:contain;

}

`;

export const DivCarrossel = styled.div`
width:100%;
height:700px;
background-size: cover;
background-repeat: no-repeat;
background-position: center;
margin-bottom:200px;
@media(max-width:800px){
    height:250px;
    margin-bottom:20px;
}

`;

export const DivCentralizaItensCarrossel = styled.div`
display:flex;
align-items: center;
width: 100%;
height: 100%;
padding:0 200px;
@media(max-width:800px){
    padding:0;
}
`
export const DivCarrosselLetreiroCentro = styled.div`
justify-content:center;
display:flex;
width: 100%;
@media(max-width:800px){
    max-height:200px;
}
`
export const DivLetreiroCentro = styled.div`
width:50%;
height:400px;
display:flex;
align-items:center;
justify-content:center;
background-color: rgba(0,0,0,0.6);
flex-direction:column;
@media(max-width:800px){
    width:80%;
    max-height:200px;
    overflow:hidden;
}
`
export const H1Letreiro = styled.h1`
color:white;
margin:20px 0;
@media(max-width:800px){
    font-size:22px;
}
`

export const PLetreiro = styled.p`
color:#fff;
padding:0 20px;
@media(max-width:800px){
    max-height:150px;
    font-size:10px;
}
`

export const DivTextoChamativo = styled.div`
    height:80px;
    width:100%;
    @media(max-width:800px){
        height:fit-content;
        margin: 0px;
        max-width:100%;
        overflow:hidden;
    }


`
export const DivInternaTextoChamativo = styled.div`
display:-webkit-box;
margin:20px 150px 0 150px;
max-width:100%;
@media(max-width:800px){
    margin:0 20px;
}

`

export const IconVoltar = styled(MdKeyboardArrowLeft)`
height:50px;
width:50px;
border:1px solid black;
border-radius:100px;
cursor: pointer;
@media(max-width:800px){
    height:30px;
    width:30px;
}

`;
export const IconAvancar = styled(MdKeyboardArrowRight)`
height:50px;
width:50px;
border:1px solid black;
border-radius:100px;
cursor: pointer;
@media(max-width:800px){
    height:30px;
    width:30px;
}


`;
export const IconInstagram = styled(FaInstagram)`
    height:30px;
    width:30px;
    min-width:30px;
    margin-right:20px;
    cursor:pointer;
`
export const IconFacebook = styled(FaFacebookSquare)`
    height:30px;
    width:30px;
    min-width:30px;
    margin-right:20px;
    cursor:pointer;

`
export const IconTwitter = styled(FaTwitter)`
    height:30px;
    width:30px;
    min-width:30px;
    margin-right:20px;
    cursor:pointer;

`
export const IconYoutube = styled(FaYoutube)`
    height:30px;
    width:30px;
    min-width:30px;
    margin-right:20px;
    cursor:pointer;

`
export const IconQuotInicio = styled(ImQuotesLeft)`
    height:30px;
    width:30px;
    color:lightgray;
    margin-right:20px;
    @media(max-width:800px){
        height:15px;
        width:15px;
        margin-right:10px;

    }
`
export const PTextoChamativo = styled.p`
 font-size: 20px;
 line-height: 35px;
 @media(max-width:800px){
     font-size:15px;
     line-height:25px;
     width:calc(100% - 25px);
     margin-bottom:20px;
 }

`

export const DivTextoApresentacao = styled.div`
height:fit-content;
width:100%;
@media(max-width:800px){
    >div{display:flex;
    justify-content:center;}
}

`


export const IconQuotFinal = styled(ImQuotesRight)`
    height:30px;
    width:30px;
`

export const ListaMenuPreview = styled.ul`
    display: flex;
    list-style: none;
    height: 80px;
    justify-content: center;
    font-weight: 500;
    align-items: center;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
`
export const OpcaoMenuPreview = styled.li`
    margin:0 20px;
    cursor:pointer;
`
export const DivOpcaoMenuPreview = styled.div`
    height:100%;
    display:flex;
    align-items:center;
    margin:0 20px;

    :hover{
        font-weight:800;
        border-top:1px solid green;
    }

`
export const InputPesquisaTopo = styled.input`
    height:30px;
    padding:0 10px;
    border: 1px solid rgba(0,0,0,0.08);
    border-radius:5px;
    background:#ffe;
`
export const DivRodape = styled.div`
   margin-bottom:50px;
   padding-right:20px;
    >h2{
        margin: 20px 0;
        @media(max-width:800px){
            font-size:20px;
        }
    };

    >p{
        margin: 25px 0;
        font-size:18px;
        @media(max-width:800px){
            font-size:15px;
        }
    };
    >button{
        color:#fff;
        height: 60px;
        width:fit-content;
        padding:0 20px;
        @media(max-width:800px){
           width:100%;
        }
    }
`
export const DivRodapeInformacoes = styled.div`
    width:100%;
    height:fit-content;
    overflow:hidden;
`
export const DivInternaInformacoes = styled.div`
    display:flex;
    margin:20px 150px;
    @media(max-width:800px){
        flex-wrap:wrap;
        align-items:center;
        justify-content:center;
        margin:0 20px;
    }

`
